// Translation: Arabic > Format
const format = Object.freeze({
	parentheses: '({{reference}})',
	range: '{{low}}–{{high}}',
	ratio: '{{primary}}/{{secondary}}',
	threeDots: '{{reference}}...'
})

// Export
export default format
